import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { MiniIcons } from 'owa-mini-icons';

/**
 * function to determine the CSS class for the icon to be rendered for respective folder
 * @param folderId for which icon class is returned
 * @param isFavorite other than favourite folders, by default render folder icon
 */
export default function getCustomIcon(folderId: string, isFavorite: boolean = true): string {
    // TODO: Possibly deprecate this in favor of getCustomIconName?
    // This is currently used by FolderPanelListItem and getDefaultIconForFolder.
    return getIconClassName(getCustomIconName(folderId, isFavorite));
}

/**
 * function to determine which icon is rendered for respective folder
 * @param folderId for which icon class is returned
 * @param isFavorite other than favourite folders, by default render folder icon
 */
export function getCustomIconName(folderId: string, isFavorite: boolean = true): string {
    const folderName = folderIdToName(folderId);
    switch (folderName) {
        case 'inbox':
            return MiniIcons.Inbox;
        case 'sentitems':
            return MiniIcons.Send;
        case 'drafts':
            return MiniIcons.Edit;
        case 'deleteditems':
            return MiniIcons.Delete;
        case 'archive':
            return MiniIcons.Archive;
        case 'junkemail':
            return MiniIcons.Blocked;
        default:
            return isFavorite ? MiniIcons.FabricFolder : null;
    }
}
